import { MessageCircle } from "lucide-react";
import { waLink } from "../lib/site";

export const WhatsAppFloat = () => (
  <a href={waLink()} target="_blank" rel="noreferrer" data-testid="whatsapp-float-btn" aria-label="Falar no WhatsApp"
    className="fixed bottom-5 right-5 z-40 grid h-14 w-14 place-items-center rounded-full bg-[#1FA855] text-white shadow-lg transition-transform hover:scale-110">
    <MessageCircle className="h-6 w-6" />
  </a>
);
